/**
 * ChplViewer - Re-exports from modular structure
 *
 * This file maintains backward compatibility with existing imports.
 * The actual implementation has been split into smaller, focused components:
 *
 * - chpl-viewer/index.tsx - Main orchestrator
 * - chpl-viewer/chapter45-content.tsx - Markdown rendering with semantic thread
 * - chpl-viewer/content-block.tsx - Individual block rendering
 * - chpl-viewer/highlighted-text.tsx - Text highlighting component
 * - chpl-viewer/hooks/use-highlight-navigation.ts - Navigation hook
 * - chpl-viewer/hooks/use-scroll-tracking.ts - Scroll tracking hook
 * - chpl-viewer/utils.ts - Utility functions
 */

export {
  ChplViewer,
  type DocumentType,
  hasPdfContent,
  type ViewMode,
} from './chpl-viewer/index';
